export default [
    'freebee', 'тенге'
];
